<template>
    <div v-if="sliderVal != undefined" class="w-auto">
        <vue-range-slider
            :id="id"
            v-model="sliderVal"
            :min="min"
            :max="max"
            :step="step"
            :tooltip-merge="tooltipMerge"
            :enable-cross="enableCross"
            :formatter="formatter"
            @slide-end="slideEnd"
        />
        <div class="range-txt flex justify-between">
            <span :key="key" v-for="(text, key) in rangeText" class="shadow-text-none">{{ text }}</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: String
        },
        value: {
            default: 0
        },
        min: {
            type: Number,
            default: 0
        },
        max: {
            type: Number,
            default: 10
        },
        step: {
            type: Number,
            default: 1
        },
        rangeText: {
            type: Array,
            default: () => []
        },
        formatter: {
            type: Function
        }
    },

    watch: {
        value(val) {
            if (val && typeof val !== 'number') {
                val = new Array(...val)
            } else if (!val && Array.isArray(val)) {
                val = [0, this.max]
            }
            this.setValue(val)
        }
    },

    created() {
        this.setValue(this.value)
    },

    data() {
        return {
            sliderVal: null,
            enableCross: false,
            tooltipMerge: false
        }
    },

    methods: {
        setValue(value) {
            this.$set(this, 'sliderVal', value)
        },

        slideEnd(value) {
            this.$emit('change', value)
        }
    }
}
</script>

<style lang="scss" scoped>
.range-txt {
    display: flex;
    justify-content: space-between;
    font-size: 12px;

    span:first-child {
        padding-left: 8px;
    }

    span:last-child {
        padding-right: 8px;
    }
}
</style>
